<app-drawer titleHeader="Resolve" [visible]="visible" (cancel)="handleCancel()">
  <ng-container drawerContent> dsad </ng-container>
  <ng-container drawerBtn>
    <button nz-button (click)="handleCancel()" [nzLoading]="isLoadingBtn">Cancel</button>
    <button nz-button nzType="primary" (click)="(handleResolveTicket)" [nzLoading]="isLoadingBtn">
      Resolve
    </button>
  </ng-container>
</app-drawer>
